export default "__VITE_ASSET__BtUKkLfO__"